import { useEffect, useState } from "react";

// Fade-in wrapper
export function FadeIn({ delay = 0, duration = 1000, children, className = "" }) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setVisible(true), delay);
    return () => clearTimeout(t);
  }, [delay]);
  return (
    <div
      className={`transition-opacity ${className}`}
      style={{ opacity: visible ? 1 : 0, transitionDuration: `${duration}ms` }}
    >
      {children}
    </div>
  );
}

// Character-by-character heading
export function AnimatedHeading({
  text,
  className = "",
  style = {},
  initialDelay = 200,
  charDelay = 30,
  charDuration = 500,
  tag = "h1",
}) {
  const [start, setStart] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setStart(true), initialDelay);
    return () => clearTimeout(t);
  }, [initialDelay]);

  const lines = text.split("\n");
  const Tag = tag;

  return (
    <Tag className={className} style={style} data-testid="hero-headline">
      {lines.map((line, lineIndex) => {
        let charOffset = lineIndex * line.length;
        return (
          <span key={lineIndex} style={{ display: "block" }}>
            {line.split(" ").map((word, wordIndex) => {
              const wordStart = charOffset;
              charOffset += word.length + 1;
              return (
                <span key={wordIndex} style={{ display: "inline-block", whiteSpace: "nowrap", marginRight: "0.25em" }}>
                  {word.split("").map((ch, charIndex) => {
                    const delay = (wordStart + charIndex) * charDelay;
                    return (
                      <span
                        key={charIndex}
                        style={{
                          display: "inline-block",
                          opacity: start ? 1 : 0,
                          transform: start ? "translateX(0)" : "translateX(-18px)",
                          transition: `opacity ${charDuration}ms ease, transform ${charDuration}ms ease`,
                          transitionDelay: `${delay}ms`,
                        }}
                      >
                        {ch}
                      </span>
                    );
                  })}
                </span>
              );
            })}
          </span>
        );
      })}
    </Tag>
  );
}
